import { http } from './http'

//登录
export const login = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/login',
        method: 'post',
        body: data,
    })

// 注册
export const register = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/register-v2',
        method: 'post',
        body: data,
    })

// 获取验证码
export const getVerifyCode = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/register-verify-code',
        method: 'get',
        query: params,
    })
// 获取邀请码
export const getInviteCode = () =>
    http({
        // baseUrl: baseUrl,
        url: '/api/public/invite-code-url',
        method: 'get',
    })

    
// 获取公司    
export const getCompany = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/search-companies',
        method: 'get',
        query: params,
    })

// 发送短信验证码
export const sendSmsCode = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/send-sms-code',
        method: 'post',
        body: params,
    })

// 手机号注册
export const registerByPhone = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/register-by-phone',
        method: 'post',
        body: params,
    })

// 手机号密码登录
export const loginByPhone = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/login-by-phone',
        method: 'post',
        body: params,
    })

// 绑定手机号
export const bindPhone = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/bind-phone',
        method: 'post',
        body: params,
    })

// 绑定邮箱
export const bindEmail = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/bind-email',
        method: 'post',
        body: params,
    })